export class AssistantPackage {
    constructor({
        coverages = [],
        price = 0,
        monthlyPrice = 0,
        id = "ASSISTANT_PACKAGE",
    }) {
        this.id = id;
        this.coverages = coverages;
        this.price = price;
        this.monthlyPrice = monthlyPrice;
    }
}
